import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleTrencher = {
  namespaced: true,

  state: {
    name: 'Trencher',
    nextSeqCode: null,
    trenchers: [],
  },

  mutations,
  getters,
  actions
}

export default moduleTrencher;